import React from 'react';
import type { ServiceCostBreakdown } from '../services/smr-admin';

interface Props {
    breakdown: ServiceCostBreakdown;
}

const fmt = (v: number) =>
    `£${v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Whole rates stay "20%", non-whole rates keep up to 2 dp ("17.5%") with trailing zeros
// trimmed. Math.round would misreport a 17.5% rate as 18%.
const fmtRate = (ratePercent: string) => Number(Number(ratePercent).toFixed(2)).toString();

export const ServiceCostSummary: React.FC<Props> = ({ breakdown }) => {
    const { items, totals, vat_rate_percent: vatRatePercent } = breakdown;
    const vatLabel = `VAT (${fmtRate(vatRatePercent ?? '0')}%)`;

    return (
        <div className="rounded-lg border border-mp-border bg-mp-background/40 p-4">
            <h2 className="text-sm font-semibold mb-3">Cost Summary</h2>
            <div className="grid grid-cols-2 gap-x-8 gap-y-1 text-sm max-w-sm">
                {items && (
                    <>
                        <span className="text-mp-muted">Items (net)</span>
                        <span className="text-right tabular-nums">{fmt(items.net)}</span>
                    </>
                )}

                <span className="text-mp-muted pt-1 border-t border-mp-border mt-1">Total (net)</span>
                <span className="text-right tabular-nums pt-1 border-t border-mp-border mt-1 font-medium">{fmt(totals.net)}</span>

                <span className="text-mp-muted">{vatLabel}</span>
                <span className="text-right tabular-nums">{fmt(totals.vat_amount)}</span>

                <span className="text-mp-muted font-medium">Total (gross)</span>
                <span className="text-right tabular-nums font-semibold">{fmt(totals.gross)}</span>
            </div>
        </div>
    );
};
